// ─── CAP languages (Appendix A fields h/i) ──────────────────────────────────
// Curated list of ISO 639-3 codes a CCD may declare for the target audience's
// language(s) (h) and the primary instructional language (i). This is a DATA
// list: adding a language is adding a ROW here — never a migration over CCDs in
// prod. The type DERIVES from the const (`as const` + indexed access), so a new
// row updates the type itself and the compiler covers the whole domain, not
// only Zod at the edge. Display names are resolved via i18n
// (`cap:languages.<code>`), never hard-coded here.
//
// The instructionalLanguageRule (TMAI, BSC/DEP) turns on when the audience
// includes a language other than the instructional one — the paradigm case is a
// TC teaching in Spanish to speakers of an indigenous language. So the list
// must carry the region's indigenous languages, not just the European four.
// TMAI is global (TCs across Africa, Asia, the Middle East), so this list grows
// by appending rows as new sites onboard.
export const CAP_LANGUAGE_CODES = [
    // Regional majority / instruction languages
    'spa', // Spanish
    'eng', // English
    'por', // Portuguese
    'fra', // French
    // Indigenous languages of Latin America (target-audience mother tongues)
    'que', // Quechua (macrolanguage)
    'quc', // K'iche'
    'grn', // Guaraní (macrolanguage)
    'aym', // Aymara
    'arn', // Mapudungun
    'nah', // Nahuatl
    // Global TMAI reach (append as sites onboard)
    'ara', // Arabic
    'swa', // Swahili
    'hin', // Hindi
    'fas', // Persian
    'zho', // Chinese
];
const CAP_LANGUAGE_SET = new Set(CAP_LANGUAGE_CODES);
/** Type guard: true when `code` is in the curated list. Used by CCD input
 *  validation (Zod refine) and narrows to `CapLanguageCode`. */
export function isCapLanguageCode(code) {
    return CAP_LANGUAGE_SET.has(code);
}
//# sourceMappingURL=cap-languages.js.map